import { render } from "./stronaRegulamin.vue?vue&type=template&id=92f0c39a&scoped=true"
const script = {}

import "./stronaRegulamin.vue?vue&type=style&index=0&id=92f0c39a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f0c39a"]])

export default __exports__